"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.find");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.join");

require("core-js/modules/es.array.map");

require("core-js/modules/es.array.reduce");

require("core-js/modules/es.array.some");

require("core-js/modules/es.function.name");

require("core-js/modules/es.map");

require("core-js/modules/es.object.assign");

require("core-js/modules/es.object.entries");

require("core-js/modules/es.object.freeze");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.get-own-property-descriptors");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.object.values");

require("core-js/modules/es.promise");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.string.split");

require("core-js/modules/es.string.trim");

require("core-js/modules/web.dom-collections.for-each");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _Text = _interopRequireDefault(require("@icare/rhythm-form-react/lib/controls/Text"));

var _Control = _interopRequireDefault(require("@icare/rhythm-form-react/lib/elements/Control"));

var _CountrySelect = _interopRequireDefault(require("../CountrySelect"));

var _InlineFields = _interopRequireDefault(require("../InlineFields"));

var _PickList = _interopRequireDefault(require("../PickList"));

var _ = require("../..");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultAddressValue = Object.freeze({
  id: null,
  addressLine1: '',
  addressLine2: '',
  addressLine3: '',
  locality: '',
  province: 'NSW',
  postalCode: '',
  country: 'AUS',
  unstructured: ''
});
var KEY_CODE = {
  enterKey: 13,
  spaceKey: 32
};
/**
 * The AddressPickList component, used for letting a user asynchronously
 * query an AddressService for addresses
 */

var AddressPickList = /*#__PURE__*/function (_React$Component) {
  _inherits(AddressPickList, _React$Component);

  var _super = _createSuper(AddressPickList);

  function AddressPickList(props) {
    var _this;

    _classCallCheck(this, AddressPickList);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_handleSearchInputFocus", function (e) {
      var onFocus = _this.props.onFocus;
      var superValue = _this.state.superValue;

      if (superValue && superValue.value && _typeof(superValue.value) === 'object' && !superValue.value.id && !superValue.value.__isSearchValueText) {
        _this.setState({
          isStructuredAddress: true
        });
      }

      onFocus(e);
    });

    _defineProperty(_assertThisInitialized(_this), "_handleResultSelect", function (newValue) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          service = _this$props.service;

      if (!newValue || !newValue.addressId) {
        _this.setState({
          superValue: null,
          isStructuredAddress: false,
          searchValueText: ''
        }, function () {
          onChange(null);
        });

        return;
      }

      var value = newValue.value,
          label = newValue.label,
          addressId = newValue.addressId; // if "ENTER MANUALLY" is selected toggle state in-order to show the correct form

      if (value === 'ENTER_MANUALLY') {
        _this._toggleManualAddressForm();

        return;
      } //TODO: Cancel request if one is pending then remove 'isDisabled'


      _this.setState({
        superValue: {
          label: label,
          value: value
        },
        searchValueText: '',
        isLoading: true,
        isDisabled: true
      });

      service.getStructuredAddress(addressId).then(function (resp) {
        _this.setState({
          isLoading: false,
          isDisabled: false
        }, function () {
          var data = resp.data;
          var address = data.attributes;

          _this._handleAddressDidChange({
            id: data.id || defaultAddressValue.id,
            addressLine1: address.addressLine1 || defaultAddressValue.addressLine1,
            addressLine2: address.addressLine2 || defaultAddressValue.addressLine2,
            addressLine3: address.addressLine3 || defaultAddressValue.addressLine3,
            locality: address.suburbOrPlaceOrLocality || defaultAddressValue.locality,
            state: address.stateOrTerritoryCode || defaultAddressValue.state,
            province: address.stateOrTerritory || defaultAddressValue.province,
            postalCode: address.postCode || defaultAddressValue.postalCode,
            country: address.countryISO || defaultAddressValue.country,
            type: data.type || defaultAddressValue.type,
            unstructured: value
          });
        });
      }).catch(function (e) {
        _this.setState({
          isLoading: false,
          isDisabled: false
        });

        throw e;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_addressToString", function (obj) {
      if (!obj) {
        return '';
      } // Create a map of address for easy searching


      var addressMap = new Map(Object.entries(obj)); // Make an array of indexes. This array will be used to build address in a particular order

      var addressIndexes = ['addressLine1', 'addressLine2', 'addressLine3', 'locality', 'suburb', 'province', 'postalCode', 'country', 'type']; // Loop through all the addresses, kicking out empty or undefined values

      return addressIndexes.map(function (addressIndex) {
        return addressMap.get(addressIndex);
      }).filter(Boolean).join(' ');
    });

    _defineProperty(_assertThisInitialized(_this), "_handleAddressDidChange", function (newValue) {
      _this.setState({
        superValue: {
          label: newValue.unstructured,
          value: newValue
        }
      }, function () {
        _this.props.onChange(_this.state.superValue.value);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleManualInputChange", function (newValue, componentName) {
      // We want to trim only completely empty values, but allow spaces when there is some content
      // Otherwise we would not be able to enter address with spaces in between words
      var normalisedValue = typeof newValue === 'string' && newValue.trim() === '' ? '' : newValue;

      _this.setState(function (state) {
        var _objectSpread2;

        var value = _objectSpread(_objectSpread({}, state.superValue.value), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, componentName, normalisedValue), _defineProperty(_objectSpread2, "id", null), _objectSpread2));

        value.unstructured = _this._addressToString(value);
        value.state = value.province;
        return _objectSpread(_objectSpread({}, state), {}, {
          superValue: {
            label: null,
            value: value
          }
        });
      }, function () {
        // If no data has been entered, populate with null
        if (Object.values(_this.state.superValue.value).find(function (v) {
          return !!v;
        }) === undefined) {
          _this.props.onChange(null);
        } else {
          _this.props.onChange(_this.state.superValue.value);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_handleSearchInputChange", function (newInput) {
      var hideDropdown = _this.state.hideDropdown;

      if (newInput.length < 3 && !hideDropdown) {
        _this.setState({
          hideDropdown: true
        });
      }

      if (newInput.length >= 3 && hideDropdown) {
        _this.setState({
          hideDropdown: false
        });
      }

      _this.setState({
        searchValueText: newInput
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_getMatchingAddresses", (0, _debounce.default)(function (searchTerm, callback) {
      var service = _this.props.service;

      _this.setState({
        isLoading: true
      });

      service.getMatchingAddresses(searchTerm).then(function (resp) {
        _this.setState({
          isLoading: false
        }); // Get address for each entry of results array


        var values = resp.data.map(function (result) {
          return {
            value: result.attributes.addressLine,
            label: result.attributes.addressLine,
            addressId: result.id
          };
        });
        callback(null, {
          options: values
        });
      }).catch(function (error) {
        return callback(error, null);
      });
    }, 500));

    _defineProperty(_assertThisInitialized(_this), "_getOptions", function (input, callback) {
      if (!input) {
        return Promise.resolve({
          options: []
        });
      }

      _this._getMatchingAddresses(input, callback);
    });

    _defineProperty(_assertThisInitialized(_this), "_toggleManualAddressForm", function (event) {
      var _this$props2 = _this.props,
          onChange = _this$props2.onChange,
          onToggle = _this$props2.onToggle;

      if (event) {
        event.preventDefault();
      }

      _this.setState(function (state) {
        return _objectSpread(_objectSpread({}, state), {}, {
          superValue: state.isStructuredAddress ? null : {
            label: '',
            value: {}
          },
          searchValueText: '',
          isStructuredAddress: !state.isStructuredAddress
        });
      }, function () {
        if (_this._firstInput) {
          _this._firstInput.focus();
        }

        onChange(null);
        onToggle();
      });

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "_optionRenderer", function (option) {
      return option.label;
    });

    _defineProperty(_assertThisInitialized(_this), "_onBlur", function (e) {
      var _this$props3 = _this.props,
          onChange = _this$props3.onChange,
          onBlur = _this$props3.onBlur;
      var searchValueText = _this.state.searchValueText;

      if (searchValueText) {
        var defValue = _objectSpread(_objectSpread({}, defaultAddressValue), {}, {
          province: '',
          country: '',
          unstructured: searchValueText
        }); // special property to detect if this is value from free text
        // @see _handleSearchInputFocus


        Object.defineProperty(defValue, '__isSearchValueText', {
          enumerable: false,
          value: true
        });
        var value = {
          label: searchValueText,
          value: defValue
        };

        _this.setState({
          superValue: value,
          searchValueText: ''
        });

        onChange(defValue);
      }

      onBlur(e);
    });

    _defineProperty(_assertThisInitialized(_this), "checkIfValidInput", function (value, error) {
      return value && !error ? 'is-filled' : '';
    });

    _defineProperty(_assertThisInitialized(_this), "_renderClearButton", function () {
      var selectInputId = _this.props.id;
      var selectInputName = _this.props.name;
      return /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        "aria-label": "Clear address value",
        className: "Select-clear-zone AddressPickList__PickList--clear-button",
        title: "Clear address value",
        onKeyDown: function onKeyDown(event) {
          var addressInput = document.querySelector("input#".concat(selectInputId || selectInputName));

          if (event.keyCode === KEY_CODE.enterKey || event.keyCode === KEY_CODE.spaceKey) {
            _this.setState({
              superValue: {
                value: ''
              }
            });

            addressInput.focus();
          }
        }
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "Select-clear"
      }, "\xD7"));
    });

    _defineProperty(_assertThisInitialized(_this), "_renderManualForm", function () {
      var _this$props4 = _this.props,
          label = _this$props4.label,
          tooltip = _this$props4.tooltip,
          labelProps = _this$props4.labelProps,
          required = _this$props4.required,
          requiredText = _this$props4.requiredText,
          tooltipProps = _this$props4.tooltipProps,
          countryList = _this$props4.countryList,
          error = _this$props4.error,
          onBlur = _this$props4.onBlur,
          onFocus = _this$props4.onFocus,
          id = _this$props4.id;
      var address = _this.state.superValue.value;
      var errorObj = {};

      if (error) {
        // Destructor error from isStructuredAddress validator into groups then the individual fields
        errorObj = error.split('.').reduce(function (accumulator, group) {
          var fields = group.split(/,\s*|\sand\s/i);
          var lastPart = fields.pop().split(/\s(?=cannot|is|must|are)/i);
          fields.push(lastPart[0]);
          return fields.filter(function (f) {
            return !!f;
          }).reduce(function (map, field) {
            map[field.trim()] = "".concat(field.trim(), " ").concat(lastPart[1]);
            return map;
          }, accumulator);
        }, {});
      }

      return /*#__PURE__*/_react.default.createElement(_Control.default, _extends({
        name: id
      }, {
        label: label,
        required: required,
        requiredText: requiredText,
        tooltip: tooltip,
        tooltipProps: tooltipProps
      }, {
        labelProps: _objectSpread(_objectSpread({}, labelProps), {}, {
          id: _this.props.id
        })
      }), /*#__PURE__*/_react.default.createElement("p", null, "Enter your address below or try to", ' ', /*#__PURE__*/_react.default.createElement("a", {
        href: "#",
        role: "button",
        onClick: _this._toggleManualAddressForm
      }, "search"), ' ', "for one again"), /*#__PURE__*/_react.default.createElement("div", {
        className: "sub-form width-l"
      }, /*#__PURE__*/_react.default.createElement(_Text.default, {
        label: "Address Line 1",
        name: "structuredAddressLine1",
        id: "".concat(id, "__structuredAddressLine1"),
        autoComplete: "address-line1",
        value: address.addressLine1,
        required: required,
        onChange: function onChange(evt) {
          _this.handleManualInputChange(evt.target.value, 'addressLine1');
        },
        width: "l",
        error: errorObj['Address Line 1'],
        onBlur: onBlur,
        onFocus: onFocus,
        className: _this.checkIfValidInput(address.addressLine1, errorObj['Address Line 1'])
      }), /*#__PURE__*/_react.default.createElement(_Text.default, {
        label: "Address Line 2",
        name: "structuredAddressLine2",
        id: "".concat(id, "__structuredAddressLine2"),
        value: address.addressLine2,
        autoComplete: "address-line2",
        onChange: function onChange(evt) {
          _this.handleManualInputChange(evt.target.value, 'addressLine2');
        },
        width: "l",
        error: errorObj['Address Line 2'],
        onBlur: onBlur,
        onFocus: onFocus,
        className: _this.checkIfValidInput(address.addressLine2, errorObj['Address Line 2'])
      }), /*#__PURE__*/_react.default.createElement(_Text.default, {
        label: "Suburb",
        name: "structuredAddressLocality",
        id: "".concat(id, "__structuredAddressLocality"),
        autoComplete: "address-level2",
        value: address.locality,
        required: required,
        onChange: function onChange(evt) {
          _this.handleManualInputChange(evt.target.value, 'locality');
        },
        width: "l",
        error: errorObj.Suburb,
        onBlur: onBlur,
        onFocus: onFocus,
        className: _this.checkIfValidInput(address.locality, errorObj.Suburb)
      }), countryList ? /*#__PURE__*/_react.default.createElement(_CountrySelect.default, {
        address: address,
        handleManualInputChange: _this.handleManualInputChange,
        checkIfValidInput: _this.checkIfValidInput,
        error: errorObj,
        required: required,
        onBlur: onBlur,
        onFocus: onFocus
      }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_InlineFields.default, {
        width: "l",
        weights: [65, 35],
        fields: [/*#__PURE__*/_react.default.createElement(_Text.default, {
          key: "state",
          label: "State",
          name: "structuredAddressProvince",
          id: "".concat(id, "__structuredAddressProvince"),
          value: address.province,
          required: required,
          autoComplete: "address-level1",
          onChange: function onChange(evt) {
            _this.handleManualInputChange(evt.target.value, 'province');
          },
          width: "l",
          error: errorObj.State,
          onBlur: onBlur,
          onFocus: onFocus,
          className: _this.checkIfValidInput(address.province, errorObj.State)
        }), /*#__PURE__*/_react.default.createElement(_Text.default, {
          key: "pc",
          label: "Postcode",
          name: "structuredAddressPostalCode",
          id: "".concat(id, "__structuredAddressPostalCode"),
          value: address.postalCode,
          required: required,
          autoComplete: "postal-code",
          onChange: function onChange(evt) {
            _this.handleManualInputChange(evt.target.value, 'postalCode');
          },
          width: "l",
          error: errorObj.Postcode,
          onBlur: onBlur,
          onFocus: onFocus,
          className: _this.checkIfValidInput(address.postalCode, errorObj.Postcode)
        })]
      }), /*#__PURE__*/_react.default.createElement(_Text.default, {
        label: "Country",
        name: "structuredAddressCountry",
        id: "".concat(id, "__structuredAddressCountry"),
        value: address.country,
        required: required,
        autoComplete: "country-name",
        onChange: function onChange(evt) {
          _this.handleManualInputChange(evt.target.value, 'country');
        },
        width: "l",
        error: errorObj.Country,
        onBlur: onBlur,
        onFocus: onFocus,
        className: _this.checkIfValidInput(address.country, errorObj.Country)
      }))));
    });

    var _superValue = null;

    if (_typeof(props.value) === 'object') {
      // if empty object then do not use it
      if (Object.values(props.value).some(function (v) {
        return !!v;
      })) {
        _superValue = {
          label: props.value ? props.value.unstructured || _this._addressToString(props.value) : '',
          value: Object.assign({}, defaultAddressValue, props.value || {})
        };
      }
    }

    _this.state = {
      hideDropdown: true,
      isLoading: false,
      isDisabled: false,
      isStructuredAddress: false,
      searchValueText: null,
      superValue: _superValue
    };
    return _this;
  }

  _createClass(AddressPickList, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
          isStructuredAddress = _this$state.isStructuredAddress,
          superValue = _this$state.superValue,
          isDisabled = _this$state.isDisabled,
          isLoading = _this$state.isLoading,
          hideDropdown = _this$state.hideDropdown; // If Address is Manual and there is a value, then render manual form.
      // If there is no value i.e when the field has been cleared, don't render.

      if (isStructuredAddress && superValue) {
        return this._renderManualForm();
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "ctrl-holder address-picklist AddressPickList"
      }, /*#__PURE__*/_react.default.createElement(_PickList.default, _extends({}, this.props, {
        className: "PickList",
        isAsync: true,
        clearable: superValue !== null,
        disabled: isDisabled,
        filterFunc: function filterFunc(options) {
          return options;
        },
        isLoading: isLoading,
        hideDropdown: hideDropdown,
        onInputChange: this._handleSearchInputChange,
        onToggleAddressForm: this._toggleManualAddressForm,
        onInputFocus: this._handleSearchInputFocus,
        onInputBlur: this._onBlur,
        onResultSelect: this._handleResultSelect,
        optionLoaderFunc: this._getOptions,
        optionRenderer: this._optionRenderer,
        searchPromptText: /*#__PURE__*/_react.default.createElement("div", null, "Type to search"),
        openOnClick: false,
        value: superValue,
        clearButtonRenderer: this._renderClearButton
      })));
    }
  }]);

  return AddressPickList;
}(_react.default.Component);

exports.default = AddressPickList;

_defineProperty(AddressPickList, "defaultProps", {
  value: null,
  label: null,
  tooltip: null,
  required: null,
  requiredText: null,
  tooltipProps: null,
  labelProps: null,
  countryList: false,
  type: 'postal',
  service: _.globalConfig.addressService,
  error: null,
  id: null,
  onToggle: function onToggle() {},
  name: null
});

_defineProperty(AddressPickList, "propTypes", {
  /**
   * Called whenever a value is selected
   */
  onChange: _propTypes.default.func.isRequired,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
    id: _propTypes.default.string,
    addressLine1: _propTypes.default.string,
    addressLine2: _propTypes.default.string,
    addressLine3: _propTypes.default.string,
    locality: _propTypes.default.string,
    province: _propTypes.default.string,
    postalCode: _propTypes.default.string,
    country: _propTypes.default.string,
    unstructured: _propTypes.default.string
  })]),
  label: _propTypes.default.string,
  tooltip: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  required: _propTypes.default.bool,
  requiredText: _propTypes.default.string,
  labelProps: _propTypes.default.object,
  tooltipProps: _propTypes.default.object,
  countryList: _propTypes.default.bool,
  type: _propTypes.default.string,
  onBlur: _propTypes.default.func.isRequired,
  onFocus: _propTypes.default.func.isRequired,
  service: _propTypes.default.func,
  error: _propTypes.default.string,
  id: _propTypes.default.string,
  onToggle: _propTypes.default.func,
  name: _propTypes.default.string
});
//# sourceMappingURL=AddressPickList.js.map